import { Component, EventEmitter, HostBinding, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-file-upload-area',
    templateUrl: './file-upload-area.component.html',
    styleUrls: ['./file-upload-area.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatProgressBar, DatePipe]
})
export class FileUploadAreaComponent {
  @Input() nomeArquivo = '';
  @Input() processandoDados = false;
  @Input() listaExtensoes = '';
  @Input() dataHoje: Date = new Date();
  @Input() cssClass = '';
  @Output() arquivoCapturado = new EventEmitter<Event>();
  @Output() arquivoLimpo = new EventEmitter<void>();

  @HostBinding('class.file-drop-area-after')
  get arquivoOuProcessando() {
    return this.nomeArquivo !== '' || this.processandoDados;
  }
}
